module.exports = __webpack_public_path__ + "img/pagination.2d7b15db.png";